module.exports = __webpack_public_path__ + "static/media/Faiza_Manoor_headshot.9232715d.jpg";